Object.assign(String.prototype, {
  maxWords(count) {
    let words = this.split(" ")
    if(words.length > count) {
      return this.split(" ").slice(0, count).join(" ") + "…"
    }
    return this
  }
})

function titleCase(str) {
  str = str.toLowerCase().split(' ');
  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
  }
  return str.join(' ');
}

// smarter version of HTMLElement that adds tidier attribute observation support
class HTMLElementPlus extends HTMLElement {
  constructor() {
    super()
  }

  attributeToProperty(name) {
    return name.replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()).replace(/[\s\-]+/g, '')
  }

  propertyToAttribute(name) {
    return name.replace(/([A-Z])/g, (m) => "-" + m[0].toLowerCase())
  }

  connectedCallback() {
    let observedAttributes = []

    // get list of properties with "Changed" handlers and their attribute names
    for(let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if(name.endsWith("Changed")) {
        let propertyName = name.substring(0, name.length - 7)
        let attributeName = this.propertyToAttribute(propertyName)
        this[propertyName] = this.getAttribute(attributeName)
        observedAttributes.push(attributeName)
      }
    }

    // get a list of attributes on the element and check if they are standard or custom
    let dummy = document.createElement("div")
    for(let attributeName of this.getAttributeNames()) {
      if(!(attributeName in dummy) && !(attributeName in observedAttributes)) {
        this[this.attributeToProperty(attributeName)] = this.getAttribute(attributeName)
        observedAttributes.push(attributeName)
      }
    }

    // setup an observer for the monitored attributes
    new MutationObserver((mutations) => {
      for(let mutation of mutations) {
        let attributeName = mutation.attributeName
        let propertyName = this.attributeToProperty(attributeName)
        this[propertyName] = this.getAttribute(attributeName)
        if(propertyName + "Changed" in this) {
          this[propertyName + "Changed"](mutation.target.getAttribute(attributeName))
        }        
      }
      if(typeof this.update == "function") {this.update()}    
    }).observe(this, {attributes: true, attributeFilter: observedAttributes})

    if(typeof this.init == "function") {this.init()}
    if(typeof this.update == "function") {this.update()}    
  }
}

var Cart = {
  pendingUpdates: {},
  updateTimerID: null,
  processUpdates: async () => {
    if(Object.keys(Cart.pendingUpdates).length == 0) {return}
    let body = new URLSearchParams(
      Object.fromEntries(Object.entries(Cart.pendingUpdates).map(([k, v]) => [`updates[${ k }]`, v]))
    )
    Cart.pendingUpdates = {}
    let response = await fetch("/cart/update.js", {method: "POST", body: body})
    if(response.status == 200) {      
      cart = await response.json()
      $(Cart).trigger("cartupdate")
    } else {
      error("failed to update items in cart")
    }    
  },
  set: (id, quantity) => {
    id = parseInt(id)
    Cart.pendingUpdates[id] = quantity
    clearTimeout(Cart.updateTimerID)
    Cart.updateTimerID = setTimeout(Cart.processUpdates, 1000)
  },
  add: (id, quantity) => {
    id = parseInt(id)
    if(id in Cart.pendingUpdates) {
      Cart.pendingUpdates[id] += quantity  
    }else{
      let existing = cart.items.find(item => item.variant_id == id)
      if(existing) {
        Cart.pendingUpdates[id] = existing.quantity + quantity  
      }else{
        Cart.pendingUpdates[id] = quantity  
      }
    }
    clearTimeout(Cart.updateTimerID)
    Cart.updateTimerID = setTimeout(Cart.processUpdates, 1000)
  }
}

// if window closed and still pending update being processed then stash them until reload
window.addEventListener("beforeunload", async () => {
  if(Object.keys(Cart.pendingUpdates).length > 0) {    
    localStorage.setItem("Cart.pendingUpdates", JSON.stringify(Cart.pendingUpdates))
  }
})

// process any stashed cart changes
if(localStorage.getItem("Cart.pendingUpdates")) {
  Cart.pendingUpdates = JSON.parse(localStorage.getItem("Cart.pendingUpdates"))
  localStorage.removeItem("Cart.pendingUpdates")
  Cart.processUpdates()
}

// smooth scroll to anchors offset by header height and new window for external links
$("a").each((i, e) => {
  // account for the fixed overlay header (or things are hidden behind it when they are scrolled to)
  if($(e).attr("href") && $(e).attr("href") != "#" && $(e).attr("href").indexOf("#") == 0) {
    let target = $(e).attr("href").substring(1)
    $(e).click((i, e) => {
      window.scrollTo({top: $(`a[name="${target}"]`).offset().top - 90, behavior: "smooth"})
      return false
  })}
})

// returns true if the element is currently visible
$.fn.isInViewport = function() {
  return ($(this).offset().top + $(this).offset().height) > $(window).scrollTop() &&
          $(this).offset().top < ($(window).scrollTop() + $(window).height())
}


// currency handling
var currencies = {}

const addCurrency = (code, country_codes, symbol, locale, rounding) => {
  currencies[code] = {code: code, country_codes: country_codes, symbol: symbol, locale: locale, rounding: rounding}
}
addCurrency("GBP", ["GB"], "&pound;", "en", 0.01)
addCurrency("USD", ["US"], "$", "en", 0.01)
addCurrency("EUR", ["BE", "EL", "LT", "PT", "BG", "ES", "LU", "RO", "CZ", "FR", "HU", "SI", "DK", "HR", "MT", "SK", "DE", "IT", "NL", "FI", "EE", "CY", "AT", "SE", "IE", "LV", "PL"], "&euro;", "de", 0.01)
addCurrency("JPY", ["JP"], "&yen;", "jp", 1.00)
addCurrency("AUD", ["AU"], "$", "en", 0.01)
addCurrency("NOK", ["NO"], "kr", "no", 0.01)
addCurrency("CHF", ["CH"], "CHF", "ch", 0.01)
addCurrency("NZD", ["NZ"], "$", "en", 0.01)
addCurrency("CAD", ["CA"], "$", "ca", 0.01)

const findCurrency = (country_code) => {for(let code in currencies) {if(currencies[code].country_codes.includes(country_code)) {return code}}}

const formatMoney = (amount) => {
  let currency = currencies[get("currency")]
  amount = (Math.round((amount * exchange_rates[currency.code]) / currency.rounding) * currency.rounding).toLocaleString(currency.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2})
  return currency.symbol + amount
}

convertCurrency = (node) => {
  if(!$(node).data("gbp")) {
    $(node).data("gbp", $(node).text().replace(/[^\d.]+/g, ""))
  }
  $(node).html(formatMoney($(node).data("gbp")))
}

const updatePrices = () => {
  $("span.money").each((i, e) => {
    convertCurrency(e)
  })
}

$(document).on("DOMNodeInserted", function(event) {
  if(event.target.nodeName == "SPAN" && event.target.classList.contains("money")) {
    convertCurrency(event.target)
  }
  $(event.target).find("span.money").each((i, child) => {
    convertCurrency(child)
  })
}) 

// forms required fields handling
refreshRequiredMessages = (form) => {
  update = (form) => {
    let anyErrors = false
    $(form).find("*[required]").each((i, e) => {
      $(e).parent().toggleClass("required", !$(e).val())
      anyErrors ||= $(e).val() == ""
    })
    $(form).trigger("validated", anyErrors)
  } 
  $(form).find("*[required]").change(() => {update(form)}) // change handler
  update(form) // perform initial check
}
$("form").each((i, e) => {
  refreshRequiredMessages(e)
})